import styled from "@emotion/styled/macro";
import { Modal } from "utils";

const AddModal = styled(Modal)`
  .modal {
    &__body {
      padding-top: 0px !important;
    }
  }
`;

export default AddModal;